import { useCreateTransfer } from 'api-hooks/transactions/transfer';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { NavigationProps } from 'types';

import TransferForm from './components/form';

export type TransfersCreateParams = null;

export default function TransfersCreate(
  props: NavigationProps<NavigationRoutes.TransfersCreate>,
) {
  const { mutateAsync, error } = useCreateTransfer();

  const onResolve = useApprovalableEdit('transfers');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
        </>
      )}
      <TransferForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
